import { Component, OnInit, Inject} from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { RptloanpopupComponent } from "../../../shared/popup/rptloanpopup/rptloanpopup.component";

import { CommonmastersService } from "../../../../commonmasters/commonmasters.service";
import { PrintddfundService } from "../../../shared/print/printddfund.service";

@Component({
  selector: 'app-rptddfundpopupp',
  templateUrl: './rptddfundpopupp.component.html',
  styleUrls: ['./rptddfundpopupp.component.css']
})
export class RptddfundpopuppComponent implements OnInit {

  BranchList: any[] = [];
  CentreList: any[] = [];

  constructor(public dialogRef: MatDialogRef<RptloanpopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private CommonmastersService: CommonmastersService,
    private printddfundService: PrintddfundService,
    ) { }

  ngOnInit() {

    this.GetBranch();
    this.GetCentre();
  }

  GenerateReports(): void {
    
    this.data.ReportName = "DDFundReport";
    this.printddfundService.GetDDFundList(this.data);
    this.dialogRef.close();
  }

  GetBranch() {
    this.CommonmastersService.GetBranchList().subscribe(data => {
      this.BranchList = data;

      this.data.BranchId = 0;
    })
  }

    GetCentre() {
      this.CommonmastersService.FetchCenterList().subscribe(data => {
      this.CentreList = data;

      this.data.CentreId = 0;
    })
  }

}
